import { Col, Row } from 'antd'
import { Button } from 'components/atoms'
import { t } from 'i18next'
import { useRef, useState } from 'react'
import styled from 'styled-components'
import { StyledSearchInput } from 'styles/styledGlobal'

const StyledColInputSearch = styled(Col)`
  margin-right: 12px;
`

const StyledSearch = styled(StyledSearchInput)`
  min-width: 240px;
`

const StyledColBtnSearch = styled(Col)`
  display: flex;
  button {
    height: 34px;
  }
`

interface IProps {
  onSearch?: (keySearch: string) => void
  onChange?: (keySearch: string) => void
  value?: string
  hideButtonSearch?: boolean
  placeholder?: string
  color?:
    | 'blue'
    | 'green'
    | 'yellow'
    | 'red'
    | 'gray'
    | 'blue-trace'
    | 'green-trace'
    | 'red-trace'
}

const Search = (props: IProps) => {
  const { onSearch, onChange, value, color, hideButtonSearch, placeholder } =
    props
  const [valuePrivate, setValuePrivate] = useState<string>(value || '')
  const valueRef = useRef<string>(value || '')

  const handleOnChange = (search: string) => {
    valueRef.current = search
    if (onChange) onChange(search)
    if (value === undefined) {
      setValuePrivate(search)
    }
  }

  return (
    <Row>
      <StyledColInputSearch>
        <StyledSearch
          size="small"
          placeholder={t(placeholder || 'please-enter-search')}
          value={value === undefined ? valuePrivate : value}
          onChange={(e) => handleOnChange(e.target.value)}
          onPressEnter={() => {
            if (onSearch) onSearch(valueRef.current)
          }}
          suffix={
            <img
              className="ic-search"
              src="/images/ic-search.svg"
              alt=""
              onClick={() => {
                if (onSearch) onSearch(valueRef.current)
              }}
            />
          }
        />
      </StyledColInputSearch>
      {!hideButtonSearch && (
        <StyledColBtnSearch>
          <Button
            color={color || 'green'}
            onClick={() => {
              if (onSearch) onSearch(valueRef.current)
            }}>
            {t('search')}
          </Button>
        </StyledColBtnSearch>
      )}
    </Row>
  )
}

export default Search
